// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../../node_modules/.pnpm/@pmmmwh+react-refresh-webpack-plugin@0.5.10_react-refresh@0.14.0_type-fest@2.19.0_webpack@5.77.0/node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
var __webpack_exports__ = __webpack_require__("./index.tsx");
